export const PURCHASE_CHAT_CONTENT_REQUEST = "PURCHASE_CHAT_CONTENT_REQUEST";
export const PURCHASE_CHAT_CONTENT_RECEIVE = "PURCHASE_CHAT_CONTENT_RECEIVE";
export const PURCHASE_CHAT_CONTENT_FAILURE = "PURCHASE_CHAT_CONTENT_FAILURE";
export const RESET_PURCHASE_CHAT_CONTENT = "RESET_POST_CONTENT_IN_CHAT";